export default "__VITE_ASSET__BqEoMl6l__"